import { newWebAction } from "../../../../../../common/factory/action.factory";
import { addNewFlowVariable } from "../../../../../../common/factory/flowVariable.factory";
import { FlowVariableBehavior } from "../../../../../../common/interfaces/flow/variable/FlowVariable"
/**
 
Example. 
-Get Okta Apps -> payload:[{app1},{app2}] paginate
--Get Groups for {apps} iterate parent payload, each response page could be a pagination, consider enable pagination 
---submit data

 * @param {*} flow 
 * @param {*} api 
 * @param {*} renderValue 
 * @param {*} oktaTokenObject 
 * @param {*} parentId 
 */
export const dig=(flow,api,renderValue,oktaTokenObject, parentId,importCredentialObject) =>{
    let moreData = []
    if(api.url === "/api/v1/apps"){

        const newFlowVar = {
            behavior: FlowVariableBehavior.APPEND_FOR_EACH,
            name: '$.response.data',
            value: '$.id',
            instruction: 'id',
        };


        const grp = newWebAction(flow, "Get groups assigned to apps (put in flow )", null, renderValue);
        grp.method = "GET"
        grp.url = "{{_links.groups.href}}";
        grp.credentialsReference = oktaTokenObject
        grp.parentId = parentId
        grp.iterator = "$"
        addNewFlowVariable(grp,newFlowVar)

    

        const usr = newWebAction(flow, "Get users assigned to apps (put in flow var)", null, renderValue);
        usr.method = "GET"
        usr.url = "{{_links.users.href}}";
        usr.credentialsReference = oktaTokenObject
        usr.parentId = parentId
        usr.iterator = "$"
        addNewFlowVariable(usr,newFlowVar)

    
        moreData.push(grp)
        moreData.push(usr)
    }
    return moreData
}